import React from "react";
import { nextEvent } from "../mock";

const TopBar = () => {
  const items = new Array(6).fill(0);
  return (
    <div className="w-full bg-[#3a2f1c] text-[#f0d7a0] text-sm py-2 overflow-hidden border-b border-[#4a3f2c]">
      <div className="marquee-track">
        {items.map((_, i) => (
          <span key={i} className="px-8 tracking-wide">
            <span className="font-semibold text-[#e8a13a]">{nextEvent.label}</span>{" "}
            {nextEvent.text}
          </span>
        ))}
        {items.map((_, i) => (
          <span key={`b-${i}`} className="px-8 tracking-wide">
            <span className="font-semibold text-[#e8a13a]">{nextEvent.label}</span>{" "}
            {nextEvent.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TopBar;
